namespace Matrix.Data {
    export interface RowCustomizationForm {
        RowCode: Serenity.LookupEditor;
        ApprovalQueueCode: Serenity.LookupEditor;
        InsertApproval: Serenity.BooleanEditor;
        UpdateApproval: Serenity.BooleanEditor;
        DeleteApproval: Serenity.BooleanEditor;
        FieldCustomizations: FieldCustomizationGrid;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class RowCustomizationForm extends Serenity.PrefixedContext {
        static formKey = 'Data.RowCustomization';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RowCustomizationForm.init)  {
                RowCustomizationForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.BooleanEditor;
                var w2 = FieldCustomizationGrid;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(RowCustomizationForm, [
                    'RowCode', w0,
                    'ApprovalQueueCode', w0,
                    'InsertApproval', w1,
                    'UpdateApproval', w1,
                    'DeleteApproval', w1,
                    'FieldCustomizations', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
